module.exports = __webpack_public_path__ + "static/img/8384_phase_function_Paper_PointsHejduk_Prediction.00b9903.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/8384_phase_function_Paper_PointsHejduk_Prediction.png
// module id = p9Sj
// module chunks = 0